export const CardShimmer = () => {
  return (
    <div className="relative border bg-white rounded-[10px] overflow-hidden animate-pulse">
      {/* Image shimmer */}
      <div className="aspect-product-desktop bg-gray-200 w-full rounded-t-[10px]" />

      <div className="p-3 space-y-3">
        {/* Title */}
        <div className="h-4 bg-gray-200 rounded w-3/4" />

        {/* Price row */}
        <div className="flex justify-between items-center">
          <div className="h-4 bg-gray-200 rounded w-20" />
          <div className="h-4 bg-gray-200 rounded w-10" />
        </div>

        {/* Button */}
        <div className="h-8 bg-gray-200 rounded-lg w-full mt-2" />
      </div>
    </div>
  );
};
